import { forwardRef } from 'react';
import { useField } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl/FormControl';
import { Radio } from './Radio';
export const RadioFieldWithControlImpl = forwardRef(function RadioFieldWithControlImpl(props, ref) {
  const {
    name,
    value: radioValue,
    onChange,
    onBlur,
    label,
    labelStyle,
    helperText,
    helperStyle,
    error,
    outerStyle,
    innerStyle,
    ...other
  } = props;
  const {
    field: {
      value,
      name: fieldName,
      onChange: fieldOnChange,
      ...otherFields
    }
  } = useField({
    ref,
    name,
    onChange,
    onBlur
  });
  return <FormControl label={label} labelStyle={{
    paddingLeft: '0px'
  }} helperText={helperText} helperStyle={helperStyle} error={error} outerStyle={outerStyle} innerStyle={innerStyle}>
			<Radio value={radioValue} {...other} {...otherFields} onChange={() => fieldOnChange(radioValue)} checked={value === radioValue} />
		</FormControl>;
});
export const RadioFieldWithControl = forwardRef(function RadioFieldWithControl(props, ref) {
  return (
    // For some reason, 'useField' is lying about what the value actually
    // is on the form, causing strange form state behavior. I decided to
    // use Math.random to re-render each radio button so the correct value
    // is actually used/updated since I couldn't figure out why it was happening
    <RadioFieldWithControlImpl key={Math.random()} ref={ref} {...props} />
  );
});